import { post, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'
import { handleApiResponse } from './api_util';

async function getTile(tileId){

  const payload={
    apiName: 'LivisiblyDashboardTileApi',
    path: `tile?tileId=${tileId}`

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}


export function useGetTile(tileId, shouldFetch=true){
  const result = useSWR(
    shouldFetch ? ['TILE', tileId] : null,
    (path) => getTile(tileId)
  );
  return result;
}

async function getGaugeTile(tileId){

  const payload={
    apiName: 'LivisiblyDashboardTileApi',
    path: `gauge_tile?tileId=${tileId}`
  }

  const restOperation = get(payload);

  const response = await restOperation.response;

  return processResponse(response)
}


export function useGetGaugeTile(tileId, shouldFetch=true){
  const result = useSWR(
    shouldFetch ? ['GAUGE_TILE', tileId] : null,
    (path) => getGaugeTile(tileId)
  );
  return result;
}
